<div>
  <input
    #propertyName="ngModel"
    id="datePicker-{{ name }}"
    class="form-control"
    (keydown)="onKeyDown($event)"
    type="text"
    [name]="name"
    [maxlength]="7"
    (ngModelChange)="updateModel($event)"
    [(ngModel)]="model"
    [required]="isRequired"
    [disabled]="isDisabled"
    placeholder="Enter Month/Year (mm/yyyy)"
    autocomplete="off"
  />
  <div validationErrors [for]="propertyName.control" [errorEmitter]="errorEmitter"></div>
</div>
